import { useState } from 'react';
import { SearchDateSingleForm } from 'src/components/common/form/search/SearchDateSingleForm';
import { useHRM2120_R01Store } from './Store_HRM2120_R01';

/** 일괄 적용 버튼에서 배정을 시작할 함수이다. */
interface Props {
    onApply: () => void; // 조회된 사원에게 입력한 배정을 적용
}

/** 조회된 사원 전원에게 적용할 방식·근무조·시작일을 한 줄로 입력한다. */
export const BulkSection_HRM2120_R01 = ({ onApply }: Props) => {
    const { HRM2120_R01BulkForm, setHRM2120_R01BulkForm, workShiftList } = useHRM2120_R01Store();
    const [datePickerVisible, setDatePickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

    const setBulkStartDate = (date: Date | undefined) => {
        if (!date) return;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        setHRM2120_R01BulkForm({ bulkStartDt: `${year}-${month}-${day}` });
    };

    return (
        <div className="flex items-center gap-2 mx-[12px] px-3 py-2 bg-gray-50 border border-gray-300">
            <strong className="whitespace-nowrap">일괄 배정</strong>
            <select
                className="border rounded h-[30px]"
                value={HRM2120_R01BulkForm.bulkType}
                onChange={event => setHRM2120_R01BulkForm({
                    bulkType: event.target.value as typeof HRM2120_R01BulkForm.bulkType,
                })}
            >
                <option value="FIX">고정 근무조</option>
                <option value="ROT">2교대 A/B 번갈아</option>
                <option value="ROTA">2교대 A조</option>
                <option value="ROTB">2교대 B조</option>
            </select>
            <select
                className="border rounded h-[30px]"
                value={HRM2120_R01BulkForm.bulkShiftCd}
                disabled={HRM2120_R01BulkForm.bulkType !== 'FIX'}
                onChange={event => setHRM2120_R01BulkForm({ bulkShiftCd: event.target.value })}
            >
                <option value="">근무조 선택</option>
                {workShiftList.map(shift => (
                    <option key={shift.shiftCd} value={shift.shiftCd}>
                        {shift.shiftNm}
                    </option>
                ))}
            </select>
            <SearchDateSingleForm
                label="적용시작"
                visible={datePickerVisible}
                setVisible={setDatePickerVisible}
                value={HRM2120_R01BulkForm.bulkStartDt
                    ? new Date(`${HRM2120_R01BulkForm.bulkStartDt}T00:00:00`)
                    : undefined}
                onChange={setBulkStartDate}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
            <button
                type="button"
                className="border rounded h-[30px] px-3 bg-white"
                onClick={onApply}
            >
                일괄 적용
            </button>
            <span className="text-xs text-gray-500 truncate">
                2교대는 교대 기준일부터 주 단위로 순서대로 바뀝니다 (A조 1번째 → 2번째…, B조는 반대)
            </span>
        </div>
    );
};
